import React from 'react'
import { PositionCell } from './PositionCell'
import { IconArrowDown } from '../../components/icons/IconArrowDown'

interface AvgPositionCellProps {
  position: number
  previous_position: number | null
}

export const AvgPositionCell = ({ position, previous_position }: AvgPositionCellProps) => {
  const current = +position.toFixed(1)
  const previous = previous_position !== null && +previous_position.toFixed(1)

  if (!current && previous) {
    return (
      <div className='flex items-center gap-2'>
        <span className='w-8'>&gt;10</span>
        <span className='flex items-center text-danger'>
          <IconArrowDown className='w-4' color='#DC2F02' />
          {11 - previous}
        </span>
      </div>
    )
  }

  return <PositionCell current={current} previous={previous} />
}
